import { Select } from 'antd';
import { debounce } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useHubspotUsersList } from '@/store';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
};

export const HubspotContactSelector: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const { hubspotUsers = [], isLoading, setSearch } = useHubspotUsersList();

  const options = useMemo(
    () =>
      hubspotUsers.map(hubspotUser => {
        let label = `${hubspotUser.email} - ${hubspotUser.name}`;
        if (hubspotUser.lastName !== null) label = label.concat(` ${hubspotUser.lastName}`);
        return {
          label,
          value: hubspotUser._id
        };
      }),
    [hubspotUsers]
  );

  const handleHubspotSearch = async (val: string) => {
    if (val === '') setSearch(undefined);
    if (val.length < 4) return;
    setSearch(val);
  };

  const handleSearch = debounce(handleHubspotSearch, 500);

  return (
    <Select
      showSearch
      allowClear
      options={options}
      onSearch={handleSearch}
      onChange={onChange}
      loading={isLoading}
      placeholder={t('SELECT_HUBSPOT_CONTACT')}
      value={value}
      filterOption={(input, option) =>
        (option?.label.toLocaleLowerCase() ?? '').includes(input.toLocaleLowerCase())
      }
    />
  );
};
